import { where } from 'firebase/firestore';
import { chunk } from 'lodash/fp';
import { useAuth } from '../components/ContextProviders/Auth';
import { useConcreteProject } from '../components/ContextProviders/ProjectContext';
import { useCollection } from './Database';
import { Article, IsChief, IsDraft, IsChangelog } from '../Types';

/*
    Ideally we handle this some other way, such as a separate implementation of useCollection for this.
    Right now, however, there's no time
*/
export function useArticlesCollection(allowedCategories: string[], retryArticles: unknown) {
  const project = useConcreteProject();
  const auth = useAuth();

  const [chunk0, chunk1, chunk2, chunk3, chunk4, chunk5, chunk6, chunk7, chunk8, chunk9] = [
    ...chunk(10, allowedCategories),
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
  ];
  const articles = [
    useCollection<Article, IsDraft & IsChief & IsChangelog>(
      chunk0.length > 0 || auth.isAdmin ? `project/${project.id}/article` : undefined,
      {},
      retryArticles,
      auth.isAdmin ? undefined : where('category', 'in', chunk0),
    ),
    useCollection<Article, IsDraft & IsChief & IsChangelog>(
      chunk1.length > 0 && !auth.isAdmin ? `project/${project.id}/article` : undefined,
      {},
      retryArticles,
      auth.isAdmin ? undefined : where('category', 'in', chunk1),
    ),
    useCollection<Article, IsDraft & IsChief & IsChangelog>(
      chunk2.length > 0 && !auth.isAdmin ? `project/${project.id}/article` : undefined,
      {},
      retryArticles,
      auth.isAdmin ? undefined : where('category', 'in', chunk2),
    ),
    useCollection<Article, IsDraft & IsChief & IsChangelog>(
      chunk3.length > 0 && !auth.isAdmin ? `project/${project.id}/article` : undefined,
      {},
      retryArticles,
      auth.isAdmin ? undefined : where('category', 'in', chunk3),
    ),
    useCollection<Article, IsDraft & IsChief & IsChangelog>(
      chunk4.length > 0 && !auth.isAdmin ? `project/${project.id}/article` : undefined,
      {},
      retryArticles,
      auth.isAdmin ? undefined : where('category', 'in', chunk4),
    ),
    useCollection<Article, IsDraft & IsChief & IsChangelog>(
      chunk5.length > 0 && !auth.isAdmin ? `project/${project.id}/article` : undefined,
      {},
      retryArticles,
      auth.isAdmin ? undefined : where('category', 'in', chunk5),
    ),
    useCollection<Article, IsDraft & IsChief & IsChangelog>(
      chunk6.length > 0 && !auth.isAdmin ? `project/${project.id}/article` : undefined,
      {},
      retryArticles,
      auth.isAdmin ? undefined : where('category', 'in', chunk6),
    ),
    useCollection<Article, IsDraft & IsChief & IsChangelog>(
      chunk7.length > 0 && !auth.isAdmin ? `project/${project.id}/article` : undefined,
      {},
      retryArticles,
      auth.isAdmin ? undefined : where('category', 'in', chunk7),
    ),
    useCollection<Article, IsDraft & IsChief & IsChangelog>(
      chunk8.length > 0 && !auth.isAdmin ? `project/${project.id}/article` : undefined,
      {},
      retryArticles,
      auth.isAdmin ? undefined : where('category', 'in', chunk8),
    ),
    useCollection<Article, IsDraft & IsChief & IsChangelog>(
      chunk9.length > 0 && !auth.isAdmin ? `project/${project.id}/article` : undefined,
      {},
      retryArticles,
      auth.isAdmin ? undefined : where('category', 'in', chunk9),
    ),
  ].reduce(
    ({ docs, loading, error }, result) => ({
      docs: [...docs, ...result.docs],
      loading: loading || result.loading,
      error: error ?? result.error,
    }),
    { docs: [], loading: false, error: undefined },
  );
  return articles;
}
